new Vue({
    el: '#resourcefinder-search',
    data: {
        search: '',
        categories: window.ResourceFinderSearchData.categories,
        resources: window.ResourceFinderSearchData.resources,
        allSelector: window.ResourceFinderSearchData.allSelector,
    },
    created: function () {
        var storageCategories = JSON.parse(localStorage.getItem('categories'));
        var categoryIds = [];
        var activeCategories = [];

        if (storageCategories != null) {
            storageCategories.forEach(function (storageCategory, key) {
                let hours = 12;
                let saved = storageCategory['created_at'];
                if ((saved && (new Date().getTime() - saved > hours * 60 * 60 * 1000)) === false) {
                    activeCategories.push(storageCategory);
                    categoryIds.push(storageCategory['element'])
                }
            });
        }
        localStorage.removeItem('categories');
        localStorage.setItem("categories", JSON.stringify(activeCategories));

        this.categories.forEach(function (category) {
            $.each(categoryIds, function (key, id) {

                if (category.id === id) {
                    category.active = true;
                }

                // set child active
                category.children.forEach(function (child) {
                    $.each(categoryIds, function (key, id) {
                        if (child.id === id) {
                            child.active = true;
                        }
                    });
                });
            });
        });
    },
    computed: {
        // Check categories from local storage, if categories are active
        activeCategories: function () {
            var activeCategories = [];
            var hasActiveCategories = this.categories.some(function (el) {
                return el.active;
            });

            this.categories.forEach(function (category) {
                if (!category.active && hasActiveCategories) {
                    return;
                }

                var children = category.children;
                var hasActiveChildren = children.some(function (el) {
                    return el.active;
                });

                if (hasActiveChildren) {
                    // Wenn die Kindelemente aktiv sind, wird automatisch das Elternelent übernommen
                    if (category.active) {
                        activeCategories.push(category.id);
                    }

                    children.filter(function (el) {
                        return el.active;
                    }).map(function (el) {
                        activeCategories.push(el.id);
                    });
                }


                // Elternelement aktiv aber Kindelemente nicht
                if (category.active && !hasActiveChildren) {
                    activeCategories.push(category.id);
                }
            });

            return activeCategories;
        },
        activeResources: function () {
            var hasActiveResource = false;
            this.resources.forEach(function (resource) {
                if (this.shouldDisplayResource(resource)) {
                    hasActiveResource = true;
                }
            }.bind(this));

            return hasActiveResource;
        }
    },
    methods: {
        shouldDisplayResource: function (resource) {
            var isActiveCategory = resource.category_ids.some(
                function (id) {
                    return this.activeCategories.includes(id);
                }.bind(this)
            );

            var search = this.search.toLowerCase();
            var name = resource.translated_name || '';
            var description = resource.translated_description || '';
            var category = resource.category_name || '';

            // Kein Suchbegriff, aber Kategorie ist aktiv -> anzeigen
            if (search === '' && isActiveCategory) {
                return true;
            }

            // Kein Suchbegriff und keine aktive Kategorie -> nichts anzeigen
            if (search === '' && !isActiveCategory) {
                return false;
            }

            // Suchbegriff suchen und anzeigen
            return name.toLowerCase().includes(search) || description.toLowerCase().includes(search) || category.toLowerCase().includes(search);
        },
        parentClickUpdate: function (category) {
            category.active = !category.active;

            var categoryStatus = category.active;
            var childs = category.children;

            childs.forEach(function (child) {
                if (categoryStatus) {
                    child.active = true;
                } else {
                    child.active = false;
                }
            });
            this.storeCategoriesToLocalStorage();
        },
        childClickUpdate: function (category, child) {
            child.active = !child.active;
            this.storeCategoriesToLocalStorage();
        },
        selectAll: function (allSelector) {
            allSelector.active = !allSelector.active;

            this.categories.forEach(function (category) {
                category.active = allSelector.active;
                var childs = category.children;

                childs.forEach(function (child) {
                    child.active = category.active;
                })
            });
            this.storeCategoriesToLocalStorage();
        },
        storeCategoriesToLocalStorage: function () {
            var categories = [];

            this.categories.forEach(function (category) {
                if (category.active) {
                    categories.push({
                        'element': category.id,
                        'created_at': new Date().getTime()
                    });
                }
                var childs = category.children;

                childs.forEach(function (child) {
                    if (child.active) {
                        categories.push(
                            {
                                'element': child.id,
                                'created_at': new Date().getTime()
                            }
                        );
                    }
                })
            });

            localStorage.setItem("categories", JSON.stringify(categories));
        }
    },
});


// WEBPACK FOOTER //
// ./Resources/assets/js/frontend.js